/* ------------------------------------------------------------------
   ContactButtonCard.js  —  Link in Bio › Links › Contact button
   (Part E, T32; BioExtras.dc.html). Edits the page's contact button;
   it is saved with the page's Save button (PUT /api/bio `contact`).
------------------------------------------------------------------ */
import React from 'react';
import { CONTACT_TYPES, DEFAULT_LABELS, LABEL_MAX, contactError } from '../../bio/bioContact';

export default function ContactButtonCard({ contact, onChange, available = true }) {
  const type = CONTACT_TYPES.find(t => t.key === contact.type) || CONTACT_TYPES[0];
  const error = contactError(contact);
  const set = patch => onChange({ ...contact, ...patch });

  return (
    <div style={card}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontWeight: 700, fontSize: 15, color: '#111827' }}>Contact button</span>
        <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 600, color: '#111827', cursor: available ? 'pointer' : 'default' }}>
          <input type="checkbox" checked={!!contact.enabled} disabled={!available}
            onChange={e => set({ enabled: e.target.checked })} />
          Show
        </label>
      </div>
      <div style={{ fontSize: 13, color: '#6b7280' }}>A big button at the top of your page.</div>

      {!available && (
        <div style={{ fontSize: 13, color: '#92400e', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '8px 10px' }}>
          The contact button isn’t ready on your account yet. Please try again later.
        </div>
      )}

      {available && (
        <>
          <div role="group" aria-label="Contact type" style={{ display: 'inline-flex', border: '1px solid #d1d5db', borderRadius: 8, overflow: 'hidden', alignSelf: 'flex-start' }}>
            {CONTACT_TYPES.map((t, i) => (
              <button key={t.key} type="button" aria-pressed={contact.type === t.key}
                onClick={() => set({ type: t.key, value: sameKind(contact.type, t.key) ? contact.value : '' })}
                style={{
                  padding: '7px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer', border: 'none',
                  borderLeft: i ? '1px solid #d1d5db' : 'none',
                  background: contact.type === t.key ? '#2563eb' : '#fff', color: contact.type === t.key ? '#fff' : '#374151',
                }}>{t.label}</button>
            ))}
          </div>

          <label style={fieldLabel}>
            {type.field}
            <input value={contact.value || ''} onChange={e => set({ value: e.target.value })}
              placeholder={type.placeholder} aria-invalid={!!error}
              inputMode={type.key === 'email' ? 'email' : type.key === 'book' ? 'url' : 'tel'}
              style={{ ...input, borderColor: error ? '#fca5a5' : '#d1d5db' }} />
          </label>
          {error && <div role="alert" style={{ fontSize: 12, color: '#dc2626', marginTop: -4 }}>{error}</div>}

          <label style={fieldLabel}>
            Button text
            <input value={contact.label || ''} onChange={e => set({ label: e.target.value })} maxLength={LABEL_MAX}
              placeholder={DEFAULT_LABELS[type.key]} style={input} />
          </label>
        </>
      )}
    </div>
  );
}

// Call and Text both take a phone number, so switching between them keeps it.
const sameKind = (a, b) => a === b || (['call', 'text'].includes(a) && ['call', 'text'].includes(b));

const card = { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 16, display: 'flex', flexDirection: 'column', gap: 10, boxShadow: '0 1px 3px rgba(0,0,0,0.04)' };
const fieldLabel = { display: 'flex', flexDirection: 'column', gap: 6, fontSize: 13, fontWeight: 600, color: '#374151' };
const input = { width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 14, fontWeight: 400, color: '#111827', outline: 'none', boxSizing: 'border-box' };
